<div id="chart">
  <apx-chart
    [series]="chartOptions().series"
    [chart]="chartOptions().chart"
    [dataLabels]="chartOptions().dataLabels"
    [plotOptions]="chartOptions().plotOptions"
    [xaxis]="chartOptions().xaxis"
    [yaxis]="chartOptions().yaxis"
    [colors]="chartOptions().colors"
  ></apx-chart>
</div>
